import React, { useState, useEffect } from 'react';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8001';

const CIDDIYET_RENK = {
  YUKSEK: { bg: '#ffebee', color: '#c62828', label: 'Yüksek' },
  ORTA: { bg: '#fff3e0', color: '#e65100', label: 'Orta' },
  DUSUK: { bg: '#e3f2fd', color: '#1565c0', label: 'Düşük' },
};

const TIP_LABEL = {
  NEGATIF_STOK: 'Negatif Stok',
  FATURASIZ_ODEME: 'Faturasız Ödeme',
  ORPHAN_HAREKET: 'Orphan Hareket',
  RECETE_PORSIYON_SIFIR: 'Reçete Porsiyon=0',
  RECETE_MALZEMESIZ: 'Malzemesiz Reçete',
  STOK_HAREKET_TUTARSIZ: 'Stok↔Hareket Tutarsız',
  NEGATIF_CARI_BAKIYE: 'Negatif Cari Bakiye',
  FATURA_SIFIR_TUTAR: 'Fatura Tutar=0',
  ANI_FIYAT_DEGISIMI: 'Ani Fiyat Değişimi',
  BUYUK_STOK_HAREKETI: 'Büyük Stok Hareketi',
};

export default function DataHealthPanel() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(false);
  const token = localStorage.getItem('access_token');

  useEffect(() => {
    fetch(`${API}/api/system/data-health`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.ok ? r.json() : null)
      .then(d => { setData(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, [token]);

  if (loading) return <div style={{ padding: 16, color: '#999' }}>Veri sağlık kontrol ediliyor...</div>;
  if (!data) return null;

  const allIssues = [
    ...(data.butuenluk || []),
    ...(data.cross_validation || []),
    ...(data.anomali || []),
  ];
  const yuksek = allIssues.filter(i => i.ciddiyet === 'YUKSEK');
  const orta = allIssues.filter(i => i.ciddiyet === 'ORTA');
  const dusuk = allIssues.filter(i => i.ciddiyet === 'DUSUK');

  // Reçete sağlık (Faz 1): ayrı endpoint ama data-health'a entegre olarak gelir
  const recipeHealth = data.recipe_health;
  const recipeProblems = (recipeHealth && recipeHealth.sorunlar) || [];
  const recipeKritik = recipeProblems.filter(p => p.severity === 'kritik');
  const recipeUyari = recipeProblems.filter(p => p.severity === 'uyari');
  const recipeBilgi = recipeProblems.filter(p => p.severity === 'bilgi');

  const skorRenk = data.saglik_skoru >= 80 ? '#2e7d32' : data.saglik_skoru >= 50 ? '#e65100' : '#c62828';
  const skorBg = data.saglik_skoru >= 80 ? '#e8f5e9' : data.saglik_skoru >= 50 ? '#fff3e0' : '#ffebee';

  return (
    <div style={{
      background: '#fff', borderRadius: 12, overflow: 'hidden',
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)', marginBottom: 20,
    }}>
      <div
        onClick={() => setExpanded(!expanded)}
        style={{
          padding: '16px 20px', cursor: 'pointer',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          borderBottom: expanded ? '1px solid #eee' : 'none',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{
            width: 48, height: 48, borderRadius: '50%',
            background: skorBg, display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontWeight: 700, fontSize: 18, color: skorRenk,
          }}>
            {data.saglik_skoru}
          </div>
          <div>
            <div style={{ fontWeight: 700, fontSize: 15, color: '#1a1a2e' }}>Veri Sağlık Skoru</div>
            <div style={{ fontSize: 12, color: '#666' }}>
              {(yuksek.length + recipeKritik.length) > 0 && <span style={{ color: '#c62828', marginRight: 12 }}>{yuksek.length + recipeKritik.length} kritik</span>}
              {(orta.length + recipeUyari.length) > 0 && <span style={{ color: '#e65100', marginRight: 12 }}>{orta.length + recipeUyari.length} uyari</span>}
              {(dusuk.length + recipeBilgi.length) > 0 && <span style={{ color: '#1565c0' }}>{dusuk.length + recipeBilgi.length} bilgi</span>}
              {allIssues.length === 0 && recipeProblems.length === 0 && <span style={{ color: '#2e7d32' }}>Sorun yok</span>}
            </div>
          </div>
        </div>
        <span style={{ color: '#999', fontSize: 18 }}>{expanded ? '▲' : '▼'}</span>
      </div>

      {expanded && (
        <div style={{ padding: '0 20px 16px', maxHeight: 600, overflow: 'auto' }}>
          {allIssues.length === 0 && recipeProblems.length === 0 ? (
            <div style={{ padding: 20, textAlign: 'center', color: '#2e7d32' }}>
              Tüm kontroller temiz — veri bütünlüğü sağlam.
            </div>
          ) : (
            <>
              {allIssues.length > 0 && (
                <>
                  <div style={{ fontWeight: 700, fontSize: 13, color: '#1a1a2e', margin: '12px 0 6px' }}>
                    Veri Bütünlük & Anomali
                  </div>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, marginBottom: 16 }}>
                    <thead>
                      <tr style={{ background: '#f8f9fa' }}>
                        <th style={{ padding: 8, textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>Ciddiyet</th>
                        <th style={{ padding: 8, textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>Tip</th>
                        <th style={{ padding: 8, textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>Detay</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allIssues
                        .sort((a, b) => {
                          const order = { YUKSEK: 0, ORTA: 1, DUSUK: 2 };
                          return (order[a.ciddiyet] || 9) - (order[b.ciddiyet] || 9);
                        })
                        .map((issue, idx) => {
                          const c = CIDDIYET_RENK[issue.ciddiyet] || CIDDIYET_RENK.DUSUK;
                          return (
                            <tr key={idx} style={{ borderBottom: '1px solid #eee' }}>
                              <td style={{ padding: 8 }}>
                                <span style={{
                                  padding: '2px 8px', borderRadius: 4,
                                  background: c.bg, color: c.color, fontSize: 11, fontWeight: 600,
                                }}>{c.label}</span>
                              </td>
                              <td style={{ padding: 8, fontWeight: 600, fontSize: 12 }}>
                                {TIP_LABEL[issue.tip] || issue.tip}
                              </td>
                              <td style={{ padding: 8, fontSize: 12, color: '#333' }}>
                                {issue.mesaj}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </>
              )}

              {recipeHealth && (
                <>
                  <div style={{ fontWeight: 700, fontSize: 13, color: '#1a1a2e', margin: '12px 0 6px' }}>
                    Reçete Sağlık
                    <span style={{
                      marginLeft: 8, padding: '2px 6px', borderRadius: 4,
                      background: recipeHealth.saglik_skoru >= 80 ? '#e8f5e9' : recipeHealth.saglik_skoru >= 50 ? '#fff3e0' : '#ffebee',
                      color: recipeHealth.saglik_skoru >= 80 ? '#2e7d32' : recipeHealth.saglik_skoru >= 50 ? '#e65100' : '#c62828',
                      fontSize: 11, fontWeight: 600,
                    }}>
                      Skor: {recipeHealth.saglik_skoru}/100
                    </span>
                    <span style={{ marginLeft: 12, fontSize: 11, color: '#666', fontWeight: 400 }}>
                      {recipeHealth.ozet?.toplam_recete} reçete · {recipeHealth.ozet?.kritik_sorunlu} kritik · {recipeHealth.ozet?.sorunlu} toplam sorunlu
                    </span>
                  </div>
                  {recipeProblems.length === 0 ? (
                    <div style={{ padding: 12, color: '#2e7d32', fontSize: 13 }}>Tüm reçeteler sağlıklı.</div>
                  ) : (
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                      <thead>
                        <tr style={{ background: '#f8f9fa' }}>
                          <th style={{ padding: 8, textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>Severity</th>
                          <th style={{ padding: 8, textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>Reçete</th>
                          <th style={{ padding: 8, textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>Sorun</th>
                          <th style={{ padding: 8, textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>Öneri</th>
                        </tr>
                      </thead>
                      <tbody>
                        {recipeProblems
                          .sort((a, b) => {
                            const order = { kritik: 0, uyari: 1, bilgi: 2 };
                            return (order[a.severity] ?? 9) - (order[b.severity] ?? 9);
                          })
                          .map((p, idx) => {
                            const sevColor = p.severity === 'kritik'
                              ? { bg: '#ffebee', fg: '#c62828' }
                              : p.severity === 'uyari'
                              ? { bg: '#fff3e0', fg: '#e65100' }
                              : { bg: '#e3f2fd', fg: '#1565c0' };
                            return (
                              <tr key={`r-${idx}`} style={{ borderBottom: '1px solid #eee' }}>
                                <td style={{ padding: 8 }}>
                                  <span style={{
                                    padding: '2px 8px', borderRadius: 4,
                                    background: sevColor.bg, color: sevColor.fg, fontSize: 11, fontWeight: 600,
                                  }}>{p.severity}</span>
                                </td>
                                <td style={{ padding: 8, fontSize: 12 }}>
                                  <div style={{ fontWeight: 600 }}>#{p.recete_id} {p.ad}</div>
                                  <div style={{ color: '#999', fontSize: 11 }}>{p.marka || '—'} · {p.tip}</div>
                                </td>
                                <td style={{ padding: 8, fontSize: 12, color: '#333' }}>{p.aciklama}</td>
                                <td style={{ padding: 8, fontSize: 11, color: '#666' }}>{p.oneri}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  )}
                </>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}
